<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
    <div class="custom-card">
        <div class="card-body d-flex row justify-content-center">
            <!-- <h3 class="custom-card-title">Recycling Bin</h3> -->

          <h3 data-bs-toggle="collapse" data-bs-target="#pendingPartners"
              class="d-flex justify-content-between align-items-center">
            <span>Pending Partners</span>
            <span class="material-symbols-outlined">keyboard_arrow_down</span>
          </h3>
          <div *ngIf="pendingPartners.length > 0;else nopendingPartners" class="mb-4 collapse" id="pendingPartners" [class.show]="pendingPartners.length > 0">
            <div *ngFor="let partner of pendingPartnersPaginated[pendingPartnersPage]; trackBy: trackByPartnerId">
              <app-partner-card [partner]="partner" (cardClicked)="onPartnerCardClicked($event)"></app-partner-card>
            </div>
          </div>
          <ng-template #nopendingPartners>
            <p class="mb-4">There are no pending partners.</p>
          </ng-template>

          <br/> <br/> <br/>


          <div id="separator"></div>
          <br/>

          <h3 data-bs-toggle="collapse" data-bs-target="#inactivePartners"
              class="d-flex justify-content-between align-items-center">
            <span>Inactive Partners</span>
            <span class="material-symbols-outlined">keyboard_arrow_down</span>
          </h3>

            <div *ngIf="rejectedPartners.length > 0;else noRejectedPartners" class="mb-4 collapse" id="inactivePartners" [class.show]="rejectedPartners.length > 0">
                <div *ngFor="let partner of rejectedPartnersPaginated[rejectedPartnersPage]; trackBy: trackByPartnerId">
                    <app-partner-card [partner]="partner" (cardClicked)="onPartnerCardClicked($event)"></app-partner-card>
                </div>
            </div>
            <ng-template #noRejectedPartners>
                <p class="mb-4">There are no inactive partners.</p>
            </ng-template>

        </div>
    </div>
</div>

<!-- <div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
    <div class="custom-card">
        <div class="card-body d-flex row justify-content-center text-center">
            <h3 class="custom-card-title">Admin Dashboard</h3>

             <h3>Pending Partners</h3>
            <div *ngIf="pendingPartners.length > 0;else nopendingPartners" class="mb-4">
                <div *ngFor="let partner of pendingPartnersPaginated[pendingPartnersPage]; trackBy: trackByPartnerId">
                    <app-partner-card [partner]="partner" (cardClicked)="onPartnerCardClicked($event)"></app-partner-card>
                </div>
            </div>
            <ng-template #nopendingPartners>
                <p class="mb-4">There are no pending partners.</p>
            </ng-template>
        </div>
    </div>
</div> -->
